import IAsset from "../../../models/IAsset";

interface VideoAssetPreviewProps {
  asset: IAsset;
}

export default function VideoAssetPreview({ asset }: Readonly<VideoAssetPreviewProps>) {
  if (!asset) return null;
  return (
    <div>
      <video controls width="320" src={`/api/Asset/${asset.blobPath}`}></video>
      <div>{asset.name}</div>
    </div>
  );
}
